import { render, staticRenderFns } from "./LedesTypeList.vue?vue&type=template&id=2fa66728&"
import script from "./LedesTypeList.vue?vue&type=script&lang=js&"
export * from "./LedesTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LedesTypeList.vue?vue&type=style&index=0&id=2fa66728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports